export const JOBS_TEAM_GET         = "JOBS_TEAM_GET"
export const JOBS_TEAM_SET         = "JOBS_TEAM_SET"
